import { render, staticRenderFns } from "./treeItem.vue?vue&type=template&id=36ce9d4c&scoped=true&"
import script from "./treeItem.vue?vue&type=script&lang=js&"
export * from "./treeItem.vue?vue&type=script&lang=js&"
import style0 from "./treeItem.vue?vue&type=style&index=0&id=36ce9d4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce9d4c",
  null
  
)

export default component.exports